{
	"page": {
		"title": "Zone Access Codes",
		"intro": "What an accreditation card grants, printed on it: <strong>zones</strong> (yellow tiles), <strong>seats</strong> (numbers on the blue band), <strong>transport</strong> and <strong>meals</strong> (red tiles). Zone access rules pick from these.",
		"add": "Add code",
		"count_one": "{{n}} code",
		"count_other": "{{n}} codes"
	},
	"kinds": {
		"ZONE": "Zones",
		"SEAT": "Seats",
		"TRANSPORT": "Transport",
		"MEAL": "Meals"
	},
	"kindOne": {
		"ZONE": "Access zone",
		"SEAT": "Seat zone",
		"TRANSPORT": "Transport",
		"MEAL": "Meal"
	},
	"filters": {
		"searchPlaceholder": "Search codes by code or name",
		"kindChips": "Kind"
	},
	"sort": {
		"kind": "By kind",
		"codeAsc": "Code A–Z",
		"codeDesc": "Code Z–A"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"description": "Description",
		"usedBy": "Rules",
		"usedByTitle": "Zone access rules that grant this code",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"order": "Order",
		"editLabel": "Edit {{code}}",
		"deleteLabel": "Delete {{code}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} code",
		"summary_other": "{{from}}–{{to}} of {{total}} codes",
		"empty": "No codes"
	},
	"empty": {
		"filteredTitle": "No codes match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No zone access codes yet",
		"noneDescription": "Add the zones, seats, transport and meals a card can grant.",
		"clearFilters": "Clear filters"
	},
	"stats": {
		"total": "Codes",
		"active": "Active",
		"inactive": "Inactive"
	},
	"form": {
		"addTitle": "Add zone access code",
		"addDescription": "A new code can be picked in zone access rules once it is active.",
		"addSubmit": "Add code",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} zone access rule grants this code — a change shows on every card it reaches.",
		"editInUse_other": "{{count}} zone access rules grant this code — a change shows on every card they reach.",
		"editEmpty": "No zone access rule grants this code yet.",
		"kindHint": {
			"ZONE": "A yellow tile on the card — a venue area the holder may enter.",
			"SEAT": "A number on the blue band — a seating area.",
			"TRANSPORT": "The red T tile. A card carries at most one transport code.",
			"MEAL": "A red tile — a meal the holder is entitled to."
		},
		"field": {
			"kind": "Kind",
			"code": "Code",
			"codeHint": "Printed on the card, as typed. Unique within its kind.",
			"name": "Name",
			"nameHint": "What the code means, in plain words.",
			"description": "Description",
			"descriptionHint": "Anything a registrar should know about it.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Order on the card and in lists, within its kind.",
			"active": "Active",
			"activeHint": "Inactive codes can't be picked in rules, and rules that name them stop granting them."
		},
		"placeholder": {
			"code": {
				"ZONE": "HQ",
				"SEAT": "1",
				"TRANSPORT": "T1",
				"MEAL": "B"
			},
			"name": {
				"ZONE": "Official Headquarters",
				"SEAT": "Athlete Preparation & Competition Area",
				"TRANSPORT": "Drop Off & Park (Dedicated)",
				"MEAL": "Breakfast"
			}
		}
	},
	"delete": {
		"title": "Delete zone access code",
		"description": "Delete <strong>{{code}}</strong> — {{name}}? This only works while no zone access rule grants it.",
		"confirm": "Delete code",
		"deleted": "{{code}} deleted.",
		"failed": "Couldn't delete code",
		"inUse": "A zone access rule still grants this code. Deactivate it instead."
	},
	"toast": {
		"added": "{{code}} added.",
		"updated": "{{code}} updated.",
		"addFailed": "Couldn't add code",
		"updateFailed": "Couldn't update code"
	},
	"errors": {
		"codeTaken": "That code already exists for this kind.",
		"invalidValue": "Invalid value"
	},
	"grid": {
		"groups": {
			"ZONE": "Access zones",
			"SEAT": "Seat zones",
			"TRANSPORT": "Transport",
			"MEAL": "Meals"
		},
		"transportNone": "None",
		"transportHint": "A card carries at most one transport code."
	},
	"rules": {
		"title": "Zone Access Rules",
		"intro": "What each card grants, by category — optionally narrowed to one function, one national federation, or both. The most specific rule that matches a card wins. Cards whose access was edited by hand keep it.",
		"count_one": "{{n}} rule",
		"count_other": "{{n}} rules",
		"add": "Add rule",
		"any": "Any",
		"filters": {
			"category": "Category",
			"federation": "National federation",
			"searchCategory": "Search categories",
			"searchFederation": "Search federations"
		},
		"table": {
			"category": "Category",
			"federation": "National federation",
			"function": "Function",
			"codes": "Access",
			"noCodes": "No access",
			"inactiveCode": "{{code}} is inactive — not granted",
			"editLabel": "Edit codes of the {{name}} rule",
			"deleteLabel": "Delete the {{name}} rule"
		},
		"pagination": {
			"summary_one": "{{from}}–{{to}} of {{total}} rule",
			"summary_other": "{{from}}–{{to}} of {{total}} rules",
			"empty": "No rules"
		},
		"empty": {
			"filteredTitle": "No rules match these filters",
			"filteredDescription": "Pick another category or federation, or clear the filters.",
			"noneTitle": "No zone access rules yet",
			"noneDescription": "Add a rule per category; its cards then get that access.",
			"clearFilters": "Clear filters"
		},
		"form": {
			"addTitle": "Add zone access rule",
			"editTitle": "Edit rule codes",
			"deleteTitle": "Delete zone access rule",
			"addDescription": "Choose who the rule is for and what it grants. You see which cards change before anything is saved.",
			"editDescription": "Who the rule is for is fixed — to change it, delete this rule and add a new one.",
			"deleteDescription": "Cards following this rule move to the next most specific rule that matches them.",
			"category": "Category",
			"categoryPlaceholder": "Pick a category",
			"categoryRequired": "Pick a category.",
			"function": "Function",
			"functionHint": "Leave empty for every function in the category.",
			"functionPickCategory": "Pick a category first.",
			"anyFunction": "Any function",
			"federation": "National federation",
			"federationHint": "Leave empty for every federation.",
			"anyFederation": "Any federation",
			"codes": "Access",
			"codesCount_one": "{{count}} code granted",
			"codesCount_other": "{{count}} codes granted",
			"noCodes": "There are no active zone access codes yet. Add them under Zone Access Codes first.",
			"loadFailed": "Couldn't load the access codes: {{error}}",
			"inactiveSelected_one": "{{codes}} is no longer active. It is dropped from this rule when you save.",
			"inactiveSelected_other": "{{codes}} are no longer active. They are dropped from this rule when you save.",
			"retry": "Try again",
			"cancel": "Cancel",
			"back": "Back",
			"preview": "Preview changes"
		},
		"preview": {
			"description": "Nothing is saved yet. Check which cards this change reaches, then apply it.",
			"loading": "Counting the cards this change reaches…",
			"failed": "Couldn't preview this change: {{error}}",
			"cardsFailed": "Couldn't load the cards: {{error}}",
			"following_one": "{{n}} card follows this rule and will change.",
			"following_other": "{{n}} cards follow this rule and will change.",
			"followingNone": "No card's access changes.",
			"custom_one": "{{n}} card has custom access and will be left alone.",
			"custom_other": "{{n}} cards have custom access and will be left alone.",
			"customNone": "No card with custom access is affected.",
			"tabsLabel": "Cards reached by this change",
			"tabFollowing": "Will change ({{n}})",
			"tabCustom": "Custom — left alone ({{n}})",
			"listEmpty": "No cards.",
			"loadMore": "Load more",
			"noAccess": "None",
			"becomes": "becomes",
			"customRuleTitle": "What the rule would give — this card keeps its own access.",
			"apply_one": "Apply to {{n}} card",
			"apply_other": "Apply to {{n}} cards",
			"saveNoCards": "Save rule",
			"deleteNoCards": "Delete rule",
			"drifted": "The cards changed since the preview. It is refreshed — check it and apply again."
		},
		"toast": {
			"saved_one": "Rule saved — {{n}} card updated.",
			"saved_other": "Rule saved — {{n}} cards updated.",
			"deleted_one": "Rule deleted — {{n}} card updated.",
			"deleted_other": "Rule deleted — {{n}} cards updated.",
			"saveFailed": "Couldn't save the rule",
			"deleteFailed": "Couldn't delete the rule"
		},
		"category": {
			"title": "Zone access rules",
			"intro": "What this category's cards grant. The most specific rule wins.",
			"manage": "Manage rules",
			"loading": "Loading rules…",
			"loadFailed": "Couldn't load the rules: {{error}}",
			"empty": "No rules for this category yet — its cards get no access.",
			"more_one": "{{n}} more rule",
			"more_other": "{{n}} more rules"
		}
	}
}
